import { useCallback } from 'react';
import { Autocomplete } from 'devextreme-react/autocomplete';

export function NameAutoComplete(props) {
  const handleValueChanged = useCallback((e) => {
    if (!e.value) props.onCleared?.();
  }, [props.onCleared]);

  const handleItemClick = useCallback((e) => {
    const item = e.component.option("selectedItem");
    props.setId?.(item.Id);
    props.onItemSelected?.(item);
  }, [props.setId, props.onItemSelected]);

  return (
    <Autocomplete
      dataSource={props.dataSource}
      valueExpr="FullName"
      searchExpr={props.searchExpr}
      maxItemCount={250}
      {...(props.itemRender ? { itemRender: props.itemRender } : {})}
      {...(props.defaultValue !== undefined ? { defaultValue: props.defaultValue } : {})}
      showClearButton
      placeholder="Type Preferred Name, First Name or Last Name..."
      onValueChanged={handleValueChanged}
      onItemClick={handleItemClick}
    />);
}